import { render, staticRenderFns } from "./TermsAndConditionsInput.vue?vue&type=template&id=d529e330&"
import script from "./TermsAndConditionsInputVue.ts?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports